import React, {useEffect, useState} from "react";

export default function AudioPreview({bookId, onClose}) {
    const [source, setSource] = useState();

    useEffect(() => {
        fetch(`/api/book/${bookId}/audio-source`).then(res => res.json()).then(res => setSource(res.source));
    }, [bookId]);

    return (
        <div className="audio-preview">
            <div className="audio-preview-body">
                <audio controls key={source}>
                    <source src={source} type="audio/mpeg"/>
                    Your browser does not support the audio element.
                </audio>
                <div
                    className="audio-preview-close"
                    onClick={onClose}
                >
                    <img src="/images/icon/square-close-icon.svg" alt="cross"/>
                </div>
            </div>
        </div>
    );
}
